<template>
  <v-row class="px-8">
    <v-col>
      <v-autocomplete
        :items="revisions"
        item-value="uuid"
        :item-text="item => `Revision #${item.order} - ${item._created}`"
        hide-details
        label="Revision"
        solo
        v-model="selectedRevision"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import orderBy from 'lodash.orderby'
import { sync } from 'vuex-pathify'
import { format } from 'date-fns'

export default {
  name: 'DuaMessageRevisionSelect',

  computed: {
    selectedRevision: sync('history/selectedDuaMessageUUID'),

    revisions() {
      return orderBy(
        this.$store.get('history/duaMessages'),
        ['created'],
        ['asc']
      ).map((x, i) => ({
        ...x,
        _created: format(new Date(x.created), 'yyyy-MM-dd HH:mm'),
        order: i + 1
      }))
    }
  },

  watch: {
    selectedRevision(value) {
      const duaMessage = this.revisions.find(x => x.uuid === value)
      this.$store.set('duaMessage/model', Object.assign({}, duaMessage))
    }
  }
}
</script>
